import { AuthGuard, CrudOp, partlistEntryAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { useRequiredProjectParam, useRequiredSubprojectParam } from "@org-avp/avp-avengers-ui-shared-store";
import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const QaMonitorView: FC = () => {
  const projectId = useRequiredProjectParam("projectId");
  const subprojectId = useRequiredSubprojectParam("subprojectId");
  const megTemplateId = useRequiredSubprojectParam("megTemplateId");
  const brand = useRequiredProjectParam("brand");
  const modelYear = parseInt(useRequiredSubprojectParam("modelYear"));
  const mbvClasses = useRequiredSubprojectParam("mbvKeys", parseArrayAndSort);

  return (
    <AuthGuard authScope={partlistEntryAuthScope} crudOp={CrudOp.READ} project={projectId}>
      <Suspense>
        <LazyQaMonitorView
          projectId={projectId}
          subprojectId={subprojectId}
          megTemplateId={megTemplateId}
          brand={brand}
          modelYear={modelYear}
          mbvClasses={mbvClasses}
        />
      </Suspense>
    </AuthGuard>
  );
};

const LazyQaMonitorView = lazy(importView(
  () => import("../components/QaMonitorView"),
  (it) => it.QaMonitorView,
));

const parseArrayAndSort = (param: string): string[] => {
  return param.split(",").sort();
};
